import { render, staticRenderFns } from "./ProductReviewReg.vue?vue&type=template&id=0578d022&scoped=true"
import script from "./ProductReviewReg.vue?vue&type=script&lang=js"
export * from "./ProductReviewReg.vue?vue&type=script&lang=js"
import style0 from "./ProductReviewReg.vue?vue&type=style&index=0&id=0578d022&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578d022",
  null
  
)

export default component.exports